import { getResponseErrors } from "../getResponseErrors";

export function getResponseCodes(response) {
  return getResponseErrors(response).map((error) => error.code);
}
